import { Component, Input, AfterViewInit, ChangeDetectorRef, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { CoreService, CustomDatepickerI18n, FilesManagerService, HttpService, I18n, QueovalDateService } from '../../../services';
import { QueovalDik, ActionCoCardModel, QueovalItem, Person, DateModel, QueovalDate, ActionCoHistory, QueovalDateTime, ActionCoHistoryType, FileModel, Corporation, GQueovalDik, ActionCoReply, Select, ActionCoTypeDevis, Historique, QResult } from '../../../models';
import { NgbDateStruct, NgbDatepickerI18n, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../toast';
import { TagComponent } from '../../../tag';

import { ActionCoService } from '../action-co-services/action-co.service';
import { HistoryService } from '../../../history';
import { BoPropertyType, DateRequiredBoProperty, IBoProperty, IntBoProperty, MonetaryBoProperty, StringBoProperty } from '../../../models/bodisplay/dynamictags-inline/dynamictags-inline.model';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-action-co-action',
  templateUrl: './action-co-action.component.html',
  styleUrls: ['./action-co-action.component.css', '../action-co-card.component.css'],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }] // define custom NgbDatepickerI18n provide
})

export class ActionCoActionComponent implements AfterViewInit {
  //  public model: ActionCoCardModel = new ActionCoCardModel();
  public diabledSave = false;

  public datePickerModel: NgbDate;

  public HistoryBoTypes: Array<Select> = new Array<Select>();
  public HistoryBoTypeValue: string = '';
  public ThumbBoTypeValue: string = '';
  public HistoryNewComment: string = '';

  public clickedThumb: string = '';

  public showCollaboDropDown: boolean = false;
  public _description: string = '';
  public datepiquerPopover: any;
  public TypePopover: any;
  public PropPopover: any;

  public isSaving: boolean = false;

  public modeBo: string = '';

  public propsWithoutCombo: number = 0;


  public highlightThumbComment: boolean = false;
  public highlightThumbStatus: boolean = false;
  public highlightSujet: boolean = false;
  public highlightDescription: boolean = false;
  public emptyComment: boolean = false;

  public maxCommentLength: number;

  public showCreatePMDiv: boolean;

  @Input() model: ActionCoCardModel;
  @Input() idActionCo: string = '';

  @Input() dataListCollabo: Array<string> = [];
  @Input() dataListContact: Array<string> = [];

  @Input() awaitNameCollabo: boolean = true;
  @Input() awaitNameContact: boolean = true;
  @Input() awaitNameCustomers: boolean = true;

  //@Input() NameCollaboConnected: string = '';
  //@Input() LogoCollaboConnected: string = '';

  @Input() Customer: Corporation = new Corporation();

  @Input('strDescription') set SetDescription(value: string) {
    this._description = value;
    if (this.description && this.description.nativeElement) {
      this.description.nativeElement.innerHTML = value;
    }
  }

  @Output() modelChange: EventEmitter<ActionCoCardModel> = new EventEmitter<ActionCoCardModel>();
  // @Output() getHistory: EventEmitter<void> = new EventEmitter<void>();
  @Output() setIdActionCo: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('description') description: ElementRef<HTMLTextAreaElement>;

  @ViewChild('tagComp', { static: false }) tagComp: TagComponent;
  @ViewChild('commentaire', { static: false }) commentaire: ElementRef<HTMLTextAreaElement>;

  constructor(
    public indParam: CoreService,
    protected http: HttpService,
    /* protected domSanitizer: DomSanitizer,*/
    public qDateService: QueovalDateService,
    protected changeDetector: ChangeDetectorRef,
    protected toast: ToastService,
    public actionCoService: ActionCoService,
    private fileService: FilesManagerService,
    protected historyService: HistoryService,
  ) { }

  public ngAfterViewInit(): void {
    //this.model.requiredProps.Dates;
    //this.model.requiredProps.Ints;
    //this.model.requiredProps.Monetaries;
    //this.model.requiredProps.Strings[0].Combo[0].;
    //this.model.requiredProps.Strings[0].Label;
    //this.model.requiredProps.Strings[0].Value


    this.Init();
  }

  //#region PUBLIC FUNCTIONS



  public SaveActionCo(): void {
    if (this.isSaving) {
      this.toast.showInfoToast('Sauvegarde déjà en cours');
    }
    else {
      let emptyValue: boolean = false;

      if (this.clickedThumb != '') {
        if (!this.model.Remark) {
          this.highlightThumbComment = true;
          emptyValue = true;
        }
        if (this.model.Status === 'Perdu' && !this.model.Reason) {
          this.highlightThumbStatus = true;
          emptyValue = true;
        }
      }

      if (!this.model.Sujet) {
        this.highlightSujet = true;
        emptyValue = true;
      }
      if (this.model.DescriptionRequired && !this.model.Description) {
        this.highlightDescription = true;
        emptyValue = true;
      }
      this.model.requiredProps.forEach(
        (prop: IBoProperty<any>) => {
          switch (prop.Type) {
            case BoPropertyType.STRING:
            case BoPropertyType.INT:
            case BoPropertyType.MONETARY:
            case BoPropertyType.DATE:
              if (!prop.Value) {
                prop.highlight = true;
                emptyValue = true;
              }
              break;
            case BoPropertyType.BOOLEAN:
              if (prop.Value == null) {
                prop.Value = false;
              }
              break;
          }
        });

      if (emptyValue) {
        this.toast.showAlertToast('veuillez renseigner les champs obligatoires');
        return;
      }

      this.isSaving = true;
      const model: ActionCoCardModel = JSON.parse(JSON.stringify(this.model));
      model.Mode = "SAVE_ACTION_CO";


      if (this.model.idActionCo && this.model.idActionCo == '0') {
        model.HistoryNewComment = this.HistoryNewComment;
      }

      this.http.postHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/`, model).toPromise().then(
        (data: QResult<ActionCoCardModel>) => {
          this.actionCoService.CanTransform();
          this.isSaving = false;
          if (!data.HasError) {
            if (!data.Value.error) {

              // Enregistrement des tags
              this.tagComp.saveTag(data.Value.idActionCo);

              this.HistoryNewComment = '';
              this.model.idActionCo = data.Value.idActionCo;
              //  this.model.History = data.History;
              this.model.Sujet = data.Value.Sujet;
              this.model.Description = data.Value.Description;
              this.actionCoService.OnActionCoCreated(this.model.idActionCo);

              if (this.clickedThumb != '') {
                this.SaveWinLose();
              } else {
                // mise à jour de l'historique
                this.historyService.GetHistory(this.actionCoService.Model.idActionCo).subscribe(() => { this.setIdActionCo.emit(this.actionCoService.Model.idActionCo); });
              }
            }
          }
        });
    }
  }
  public SaveWinLose(): void {
    if (!this.model.Remark || (this.model.Status === 'Perdu' && !this.model.Reason)) {
      this.toast.showWarningToast('Veuillez renseigner les champs obligatoires');
      return;
    }
    const model: ActionCoCardModel = JSON.parse(JSON.stringify(this.model));
    model.Mode = 'SAVE_WIN_LOSE';
    model.BoTypeValueSelected = this.ThumbBoTypeValue;

    this.http.postHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/`, model).subscribe(
      (result: QResult<ActionCoCardModel>) => {
        this.model.Reason = result.Value.Reason;
        this.model.Remark = result.Value.Remark;
        this.model.Status = result.Value.Status;
        this.model.lockThumb = result.Value.lockThumb;
        this.clickedThumb = '';
        //  this.model.History = result.History;
        this.model.Customer.PersonneMorale = result.Value.Customer.PersonneMorale;
        this.model.Customer.IsClient = result.Value.Customer.IsClient;
        this.actionCoService.SetInfoDevis(result.Value);
        // mise à jour de l'historique
        this.historyService.GetHistory(this.actionCoService.Model.idActionCo).subscribe(() => { this.setIdActionCo.emit(this.actionCoService.Model.idActionCo); });

      });

  }

  public OnCollaboChange(Collabo: Array<Person>): void {
    if (Collabo && Collabo.length) {
      this.model.NameCollabo = Collabo[0].Value;
      const collabo: Person = Collabo[0]; //this.model.Collaborateurs.filter(x => x.Value === strCollabo)[0]
      this.model.IdCollabo = collabo.Id;
      this.model.LogoCollabo = collabo.ProfilePicture;
    }
  }
  public OnCustomerChange(strCustomer: QueovalItem): void {
    if (strCustomer.Value != 'DELETE') {
      if (this.model.Customer.Id != strCustomer.Value) {
        this.model.Customer.SocialReason = strCustomer.Text;
        this.model.Customer.Id = strCustomer.Value;
        this.awaitNameCustomers = true;
        if (([ActionCoTypeDevis.lettreDeMission, ActionCoTypeDevis.CAC] as string[]).includes(this.actionCoService.Model.TypeDevis)) {
          this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/IS_MODE_ACTION_CO_VALID/${this.model.Customer.Id}|${this.actionCoService.Model.TypeDevis}`).subscribe(
            (data: QResult<ActionCoCardModel>) => {
              this.diabledSave = data.Value.error;
            });
        }

        this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_CUSTOMER_DATAS/${this.model.Customer.Id}`).subscribe(
          (data: QResult<ActionCoCardModel>) => {
            this.model.Customer = JSON.parse(JSON.stringify(data.Value.Customer));
            this.actionCoService.OnCorpIsClient(this.model.Customer.IsClient);
            setTimeout(() => { this.awaitNameCustomers = false; });
          });
        this.awaitNameContact = true;
        this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_CONTACTS_BY_ID_CUSTOMER/${this.model.Customer.Id}`).subscribe(
          (data: QResult<ActionCoCardModel>) => {
            this.model.ContactPrincipal = new Person();
            this.model.Contacts = data.Value.Contacts;
            this.dataListContact = data.Value.Contacts.map(c => c.Value);
            setTimeout(() => { this.awaitNameContact = false; });
          });
      }
    } else {
      this.awaitNameContact = true;
      this.model.Customer.SocialReason = '';
      this.model.Customer.Id = '';
      this.model.ContactPrincipal = new Person();
      this.model.Contacts = [];
      this.dataListContact = [];
      setTimeout(() => { this.awaitNameContact = false; });
    }
  }

  public OnContactChange(strContact: string): void {
    this.model.ContactPrincipal.Value = strContact;
    if (!strContact) {
      this.model.ContactPrincipal = new Person();
    }
    else {
      const contact = this.model.Contacts.filter(x => x.Value === strContact)[0];
      this.model.ContactPrincipal = JSON.parse(JSON.stringify(contact));
    }

  }
  //public getUrl(url: string): string {
  //  return this.domSanitizer.bypassSecurityTrustResourceUrl(url) as string;
  //}
  public dateChange(date: DateModel): void {
    const changedDate: DateModel = date as DateModel;
    this.model.Date.annee = changedDate.year.toString();
    this.model.Date.mois = changedDate.month.toString();
    this.model.Date.jour = changedDate.day.toString();
    this.model.Date = new QueovalDateTime(this.model.Date.annee, this.model.Date.mois, this.model.Date.jour, this.model.Date.heures, this.model.Date.minutes);
    this.datePickerModel = new NgbDate(Number.parseInt(this.model.Date.annee), Number.parseInt(this.model.Date.mois), Number.parseInt(this.model.Date.jour));
  }
  public dateGetNow(): void {
    const now: Date = new Date();
    this.model.Date = new QueovalDateTime(now.getFullYear().toString(), (now.getMonth() + 1).toString(), now.getDate().toString(), now.getHours().toString(), now.getMinutes() >= 30 ? "30" : "00", "00");
    this.datePickerModel = new NgbDate(Number.parseInt(this.model.Date.annee), Number.parseInt(this.model.Date.mois), Number.parseInt(this.model.Date.jour));
  }
  public ClockBackground(): string {
    if (this.model && this.model.Date && !this.qDateService.IsNull(this.model.Date)) {
      const qNow: QueovalDate = this.qDateService.Now();
      if (this.qDateService.Compare(this.model.Date, '<', qNow)) return 'q-danger';
      if (this.qDateService.Compare(this.model.Date, '=', qNow)) return 'q-warning';
      return 'q-success';
    }
    return 'q-danger';
  }
  public TexteareaAutoGrow(oField: any): void {
    if (oField.currentTarget != null) {
      const target: any = oField.currentTarget;
      target.style.height = '1px';
      target.style.height = target.scrollHeight + "px";
    }
  }
  public OnThumbClicked(value: string): void {
    if (this.clickedThumb === value) {
      this.clickedThumb = '';
      this.model.Status = '';
      return;
    }
    this.clickedThumb = value;
    this.model.Status = value === 'down' ? 'Perdu' : value === 'up' ? 'Gagne' : '';
    setTimeout(() => { this.commentaire.nativeElement.focus(); }, 200);
  }
  public OpenInvoice(): void {
    const fileModel: FileModel = new FileModel();
    fileModel.Ident = this.model.Invoice.Ident;
    fileModel.Extension = '.pdf';
    fileModel.FullPath = this.model.Invoice.Path;
    fileModel.Name = `${this.model.Invoice.Name}${fileModel.Extension}`;
    fileModel.DownloadMode = 'OPENPDF';
    this.fileService.downloadFile(fileModel);
  }

  //#region date
  public OnHourChange(hour: string): void {
    this.model.Date.heures = hour;
  }
  public OnMinutesChange(minute: string): void {
    this.model.Date.minutes = minute;
  }
  public OnChangeType(type: string): void {
    this.model.Type = type;
    this.TypePopover.close();
  }

  public OnPropHourChange(Prop: DateRequiredBoProperty, hour: string): void {
    if (Prop.Value != null) {
      Prop.Value.heures = hour;
    } else {
      Prop.Value = new QueovalDateTime();
      Prop.Value.heures = hour;
    }
  }

  public OnPropMinutesChange(Prop: DateRequiredBoProperty, minute: string): void {
    if (Prop.Value != null) {
      Prop.Value.minutes = minute;
    } else {
      Prop.Value = new QueovalDateTime();
      Prop.Value.minutes = minute;
    }
  }
  public datePropChange(Prop: DateRequiredBoProperty, date: DateModel): void {
    let heures: string = Prop.Value != null ? Prop.Value.heures : '00';
    let minutes: string = Prop.Value != null ? Prop.Value.minutes : '00';
    Prop.Value = new QueovalDateTime(date.year.toString(), date.month.toString(), date.day.toString(), heures, minutes);
  }
  //#endregion date

  public OnChangeComboValue(Prop: IntBoProperty | StringBoProperty | DateRequiredBoProperty | MonetaryBoProperty, value: any): void {
    Prop.Value = value;
    this.TypePopover.close();
  }

  public AfficheSelectedType(typeCode: string): string {
    if (this.model && this.model.TypesList && this.model.TypesList.length > 0) {
      var selectedValue = this.model.TypesList.filter((type: QueovalDik) => type.key === typeCode);
      if (selectedValue && selectedValue.length > 0 && selectedValue[0] != null) return selectedValue[0].value;
      this.model.Type = this.model.TypesList[0].key;
      return this.model.TypesList[0].value;
    }
    return this.model.Type;
  }

  public AfficheComboValue(Prop: any): string {
    var selectedValue = (Prop.Combo as Array<GQueovalDik<string, any>>).filter((combo: GQueovalDik<string, any>) => combo.Value === Prop.Value)
    if (selectedValue && selectedValue.length > 0 && selectedValue[0] != null) return selectedValue[0].Key;
    Prop.Value = (Prop.Combo as Array<GQueovalDik<string, any>>)[0].Value
    return (Prop.Combo as Array<GQueovalDik<string, any>>)[0].Key;
  }

  public NbPropsWithoutCombo(lstProps: Array<IBoProperty<any>>): number {
    return lstProps.filter((prop: IBoProperty<any>) => !prop.Combo || prop.Combo.length < 1).length;
  }

  public OnOpenBo(type: string): void {
    switch (type) {
      case 'PM':
        this.modeBo = 'CUSTOMER';
        this.showCreatePMDiv = false;
        break;
      case 'IND':
        this.modeBo = 'INDIVIDUEL';
        this.showCreatePMDiv = false;
        break;
      case 'PP':
        this.modeBo = 'CONTACT';
        break;
      case 'ACO':
        this.modeBo = 'ACTIONCO';
        break;
      case 'PM_EDIT':
        this.modeBo = 'PM_EDIT';
        break;
      case 'PP_EDIT':
        this.modeBo = 'PP_EDIT';
        break;
    }
  }
  public OnCloseBo(mode: string, value: QueovalItem): void {
    this.modeBo = '';
    this.actionCoService.CanTransform();
    if (value && value.Value) {
      switch (mode) {
        case 'PM_EDIT':
          const reloadContacts: boolean = this.model.Customer.Id != value.Value;
          this.model.Customer.SocialReason = value.Text;
          this.model.Customer.Id = value.Value;
          this.awaitNameCustomers = true;
          this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_CUSTOMER_DATAS/${this.model.Customer.Id}`).subscribe(
            (data: QResult<ActionCoCardModel>) => {
              this.model.Customer = JSON.parse(JSON.stringify(data.Value.Customer));
              this.Customer = JSON.parse(JSON.stringify(data.Value.Customer));
              setTimeout(() => { this.awaitNameCustomers = false; });
            });
          if (reloadContacts) {
            this.awaitNameContact = true;
            this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_CONTACTS_BY_ID_CUSTOMER/${this.model.Customer.Id}`).subscribe(
              (data: QResult<ActionCoCardModel>) => {
                this.model.ContactPrincipal = new Person();
                this.model.Contacts = data.Value.Contacts;
                this.dataListContact = data.Value.Contacts.map(c => c.Value);
                setTimeout(() => { this.awaitNameContact = false; });
              });
          }

          break;
        case 'INDIVIDUEL':
          const reloadContactsInd: boolean = this.model.Customer.Id != value.Value;
          this.awaitNameCustomers = true;
          this.model.Customer.Id = value.Value;
          // construit un model CORPORATION pour le display
          this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_CUSTOMER_DATAS/${this.model.Customer.Id}`).subscribe(
            (data: QResult<ActionCoCardModel>) => {
              this.model.Customer = data.Value.Customer;
              //this.Customer = data.Value.Customer;
              this.awaitNameCustomers = false;
            });
          if (reloadContactsInd) {
            this.awaitNameContact = true;
            // construit un model PERSON et une liste de PERSON pour le display
            this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_CONTACTS_BY_ID_CUSTOMER/${this.model.Customer.Id}`).subscribe(
              (data: QResult<ActionCoCardModel>) => {
                this.model.ContactPrincipal = data.Value.Contacts[0];
                this.model.Contacts = data.Value.Contacts;
                this.dataListContact = data.Value.Contacts.map(c => c.Value);
                this.awaitNameContact = false;
              });
          }
          break;

        case 'CUSTOMER':
          this.OnCustomerChange(value);
          break;
        case 'PP_EDIT':
        case 'CONTACT':
          this.awaitNameContact = true;
          this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_CONTACTS_BY_ID_CUSTOMER/${this.model.Customer.Id}`).subscribe(
            (data: QResult<ActionCoCardModel>) => {
              this.model.ContactPrincipal = data.Value.Contacts.find(contact => contact.Id == value.Value) as Person;
              this.model.Contacts = data.Value.Contacts;
              this.dataListContact = data.Value.Contacts.map(c => c.Value);
              setTimeout(() => { this.awaitNameContact = false; });
            });
          break;

        case 'ACTIONCO':
          this.setIdActionCo.emit(this.actionCoService.Model.idActionCo);
          this.GetRequiredProps();
          break;
      }
    } else if (mode == 'ACTIONCO') {
      this.GetRequiredProps();
    }
  }

  /**
   * Mise à jour en arrière plan de l'historique pour le pipe
   **/
  public updateHistory(listHistories: Historique[]): void {
    // mise à jour de l'historique uniquement si le nombre change 
    if (listHistories.length !== this.historyService.ListHistories.length) {
      this.historyService.GetHistory(this.actionCoService.Model.idActionCo).subscribe(() => { this.setIdActionCo.emit(this.actionCoService.Model.idActionCo); });
    }

  }

  //#endregion
  //#region  PRIVATE FUNCTIONS
  private Init(): void {
    this.actionCoService.CanTransform();

    if (this.dataListContact && this.dataListContact.length > 0) {
      this.awaitNameContact = false;
    }

    this.datePickerModel = new NgbDate(Number.parseInt(this.model.Date.annee), Number.parseInt(this.model.Date.mois), Number.parseInt(this.model.Date.jour));
    if (this.description && this.description.nativeElement && !this.description.nativeElement.innerHTML) {
      this.description.nativeElement.innerHTML = this._description;
    }

    // Récupération de la liste des types d'historique d'action co pour le gagné/perdu
    this.GetTypeHistoActionCo();

    this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_DATE_MINUTES_OPTIONS_LIST/0/`).subscribe(
      (result: QResult<ActionCoCardModel>) => {
        this.model.DateMinutesList = result.Value.DateMinutesList;
      });
    this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_TYPE_VALUES_AUTOS/0/`).subscribe(
      (result: QResult<ActionCoCardModel>) => {
        this.model.TypesList = result.Value.TypesList;
      });
    this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_LOSE_REASONS/0/`).subscribe(
      (result: QResult<ActionCoCardModel>) => {
        this.actionCoService.Model.ReasonsList = this.model.ReasonsList = result.Value.ReasonsList;
      });
    this.GetRequiredProps();
  }

  private GetRequiredProps(): void {
    this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_REQUIRED_BO_PROPS/${this.model.idActionCo}/`).subscribe(
      (data: QResult<ActionCoCardModel>) => {
        this.model.DescriptionRequired = data.Value.DescriptionRequired;
        this.model.requiredProps = data.Value.requiredProps;
        this.propsWithoutCombo = this.NbPropsWithoutCombo(this.model.requiredProps);
      });
  }


  public GetTypeHistoActionCo(): void {

    this.http.getHttp<QResult<ActionCoCardModel>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_TYPE_HISTO_ACTIONCO/0/`).subscribe(
      (data: QResult<ActionCoCardModel>) => {
        this.ThumbBoTypeValue = data.Value.ActionCoHistory.BoTypeValue;
        this.HistoryBoTypes = data.Value.ActionCoHistory.BoTypes;
        this.maxCommentLength = data.Value.ActionCoHistory.MaxLengthValue;
        this.HistoryBoTypeValue = data.Value.ActionCoHistory.BoTypeValue;
      });
  }
  //#endregion
}
